/** US states plus DC, alphabetical by full name. Stored and shown as abbreviations. */
export const US_STATES = [
  { name: "Alabama", abbr: "AL" },
  { name: "Alaska", abbr: "AK" },
  { name: "Arizona", abbr: "AZ" },
  { name: "Arkansas", abbr: "AR" },
  { name: "California", abbr: "CA" },
  { name: "Colorado", abbr: "CO" },
  { name: "Connecticut", abbr: "CT" },
  { name: "Delaware", abbr: "DE" },
  { name: "District of Columbia", abbr: "DC" },
  { name: "Florida", abbr: "FL" },
  { name: "Georgia", abbr: "GA" },
  { name: "Hawaii", abbr: "HI" },
  { name: "Idaho", abbr: "ID" },
  { name: "Illinois", abbr: "IL" },
  { name: "Indiana", abbr: "IN" },
  { name: "Iowa", abbr: "IA" },
  { name: "Kansas", abbr: "KS" },
  { name: "Kentucky", abbr: "KY" },
  { name: "Louisiana", abbr: "LA" },
  { name: "Maine", abbr: "ME" },
  { name: "Maryland", abbr: "MD" },
  { name: "Massachusetts", abbr: "MA" },
  { name: "Michigan", abbr: "MI" },
  { name: "Minnesota", abbr: "MN" },
  { name: "Mississippi", abbr: "MS" },
  { name: "Missouri", abbr: "MO" },
  { name: "Montana", abbr: "MT" },
  { name: "Nebraska", abbr: "NE" },
  { name: "Nevada", abbr: "NV" },
  { name: "New Hampshire", abbr: "NH" },
  { name: "New Jersey", abbr: "NJ" },
  { name: "New Mexico", abbr: "NM" },
  { name: "New York", abbr: "NY" },
  { name: "North Carolina", abbr: "NC" },
  { name: "North Dakota", abbr: "ND" },
  { name: "Ohio", abbr: "OH" },
  { name: "Oklahoma", abbr: "OK" },
  { name: "Oregon", abbr: "OR" },
  { name: "Pennsylvania", abbr: "PA" },
  { name: "Rhode Island", abbr: "RI" },
  { name: "South Carolina", abbr: "SC" },
  { name: "South Dakota", abbr: "SD" },
  { name: "Tennessee", abbr: "TN" },
  { name: "Texas", abbr: "TX" },
  { name: "Utah", abbr: "UT" },
  { name: "Vermont", abbr: "VT" },
  { name: "Virginia", abbr: "VA" },
  { name: "Washington", abbr: "WA" },
  { name: "West Virginia", abbr: "WV" },
  { name: "Wisconsin", abbr: "WI" },
  { name: "Wyoming", abbr: "WY" },
];

function lookupStateAbbr(value) {
  const text = String(value ?? "").trim();
  if (!text) return "";
  const byAbbr = US_STATES.find((state) => state.abbr === text.toUpperCase());
  if (byAbbr) return byAbbr.abbr;
  const lower = text.toLowerCase();
  const byName = US_STATES.find((state) => state.name.toLowerCase() === lower);
  return byName?.abbr || "";
}

/** Abbreviation for display. Known full names become AL, FL, and so on. */
export function formatStateAbbr(value) {
  const known = lookupStateAbbr(value);
  if (known) return known;
  const text = String(value ?? "").trim();
  if (!text) return "";
  if (text.length === 2) return text.toUpperCase();
  return text;
}

/** Value stored by the state dropdown. Known names and codes become the abbreviation. */
export function normalizeStateValue(value) {
  const known = lookupStateAbbr(value);
  if (known) return known;
  return String(value ?? "").trim();
}

export function stateByPrefix(prefix, afterAbbr) {
  const query = String(prefix || "").toLowerCase();
  if (!query) return null;
  const startAt = afterAbbr
    ? US_STATES.findIndex((state) => state.abbr === afterAbbr) + 1
    : 0;
  const start = startAt > 0 ? startAt : 0;
  for (let i = 0; i < US_STATES.length; i += 1) {
    const state = US_STATES[(start + i) % US_STATES.length];
    if (state.name.toLowerCase().startsWith(query)) return state;
  }
  return null;
}
